import { IconInfo } from '../../react/features/base/icons/svg';
import { CONFERENCE_INFO } from '../../react/features/conference/components/constants';
import { COMPONENTS } from '../../react/features/conference/components/web/ConferenceInfo';
import {
    isNoiseSuppressionEnabled
} from '../../react/features/noise-suppression/functions';
import { SETTINGS_TABS } from '../../react/features/settings/constants';
import { IMAGES } from '../../react/features/virtual-background/constants';
import AdvancedTab from '../components/advanced-tab/components/web/AdvancedTab';
import { submitAdvancedTab } from '../components/advanced-tab/components/web/actions';
import { ADVANCED_TAB_NAME } from '../components/advanced-tab/constants';
import { HintsTooltip } from '../components/hints';
import NoiseSuppressionLabel
    from '../components/noise-suppression/components/web/NoiseSuppressionLabel';
import { getNewNoiseSuppressionType } from '../components/noise-suppression/functions';
import VideoQualityLabel from '../components/pressure-observer/components/VideoQualityLabel';
import QualityControl from '../components/quality-control/components/web/QualityControl';
declare var APP: Object;

/**
 * This class will be used for overrides of the origin Jitsi data
 */
export default class OverrideExports {
    constructor() {
        this.overrideVirtualBackgroundImages();
        this.getConferenceInfoComponents();
    }

    /**
     * Change default virtual background images to the Wildix ones.
     *  WMS-14278
     */
    overrideVirtualBackgroundImages() {
        // clean up the origin array
        IMAGES.length = 0;

        // push a new data
        IMAGES.push(
            {
                tooltip: 'wildix-image1',
                id: '1',
                src: 'images/virtual-background/wildix-background-1.png'
            },
            {
                tooltip: 'wildix-image2',
                id: '2',
                src: 'images/virtual-background/wildix-background-2.png'
            },
            {
                tooltip: 'wildix-image3',
                id: '3',
                src: 'images/virtual-background/wildix-background-3.png'
            },
            {
                tooltip: 'wildix-image4',
                id: '4',
                src: 'images/virtual-background/wildix-background-4.png'
            },
            {
                tooltip: 'wildix-image5',
                id: '5',
                src: 'images/virtual-background/wildix-background-5.jpg'
            }
        );
    }

    getSettingsTabs(tabs) {
        const state = APP.store.getState();
        const { enabled, enabledSoundHints, presetHints } = state['wildix/features/hints'];
        const { iAmVisitor } = state['features/visitors'];
        const {
            isAutoPip = true,
            isTranscriptionAutostart = true,
            isRecordingAutostart = true,
            isPreJoinScreen = false,
            isPreJoinScreenExternal = false
        } = state['wildix/customStorageSettings'];
        const isPbxUser = state['features/base/settings']?.ctijid;

        // @ts-ignore

        const arr = [
            {
                name: ADVANCED_TAB_NAME,
                component: AdvancedTab,
                labelKey: 'settings.advanced',
                styles: 'advanced-tab',
                props: {
                    autoPipEnabled: isAutoPip,
                    enabled,
                    enabledSoundHints,
                    presetHints,
                    suppressionType: getNewNoiseSuppressionType(state),
                    noiseSuppressionEnabled: isNoiseSuppressionEnabled(state),
                    transcriptionAutostart: isTranscriptionAutostart,
                    recordingAutostart: isRecordingAutostart,
                    preJoinScreen: isPbxUser ? isPreJoinScreen : isPreJoinScreenExternal,
                    isPbxUser
                },
                propsUpdateFunction: (tabState, newProps) => {
                    // Updates tab props, keeping users selection

                    return {
                        ...newProps,
                        autoPipEnabled: tabState.autoPipEnabled,
                        enabled: tabState.enabled,
                        enabledSoundHints: tabState.enabledSoundHints,
                        presetHints: tabState.presetHints,
                        suppressionType: tabState.suppressionType,
                        noiseSuppressionEnabled: tabState.noiseSuppressionEnabled,
                        transcriptionAutostart: tabState.transcriptionAutostart,
                        recordingAutostart: tabState.recordingAutostart,
                        preJoinScreen: tabState.preJoinScreen
                    };
                },
                submit: submitAdvancedTab,
                canPush: !iAmVisitor,
                icon: IconInfo,
                settings: { HINTS: ADVANCED_TAB_NAME }
            }
        ];

        arr.forEach(item => {
            if (item.canPush) {
                Object.assign(SETTINGS_TABS, item.settings);
                item.name = item.settings.HINTS;
                tabs.push(item);
            }
        });

        return tabs;
    }

    getConferenceInfoComponents() {
        // add custom components to conference info (only for web)

        const { autoHide, alwaysVisible } = CONFERENCE_INFO;
        const customComponents = [
            {
                Component: NoiseSuppressionLabel,
                id: 'noise-suppression-label',
                isAlwaysVisible: false
            },
            {
                Component: VideoQualityLabel,
                id: 'video-quality',
                replace: true
            },
            {
                Component: QualityControl,
                id: 'quality-control',
                isAlwaysVisible: true
            },
            {
                Component: HintsTooltip,
                id: 'hints-top',
                isAlwaysVisible: false
            }
        ];

        customComponents.forEach(c => {
            if (c.replace) {
                const index = COMPONENTS.findIndex(origComponent => c.id === origComponent.id);

                if (index !== -1) {
                    COMPONENTS[index] = c;
                }

                return;
            }

            COMPONENTS.push(c);

            if (c.isAlwaysVisible) {
                alwaysVisible.push(c.id);
            } else {
                autoHide.push(c.id);
            }
        });
    }
}
